﻿import $ from 'jquery';
import { IRemoteHandler, IRemoteOptions } from "./remote";
import Ajax from "./ajax";
import {EditorTable} from "../editortable/editortable"
import Utility from "../editortable/utility";
import "../../utilities/disable"

export class EditorTableFieldChangeRemoteHandler implements IRemoteHandler {
  public handle($element: JQuery, options: IRemoteOptions): boolean {
    var shouldHandle = $element.is('input[data-et-remote]') && $element.isEnabled();
    if (!shouldHandle)
      return false;

    options.$triggeringEvent?.preventDefault();

    var name = $element.data('et-remote-name-override') ||
      Utility.relativeName($element.attr('name'));
    var value = $element.val();
    var data = {}
    data[name] = value;

    var additionalValues = $element.data("et-additional-values");
    if (additionalValues)
      Object.keys(additionalValues).forEach(key => {
        var formattedKey = Utility.relativeName(key);
        data[formattedKey] = additionalValues[formattedKey];
      });

    options.url = options.url || $element.data('url');
    options.data = data;

    Ajax.execute($element, options);
    return true;
  }
}
